import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  NavLink,
  Navigate,
  NavLink as ReactLink,
  useNavigate,
  Link
} from "react-router-dom";
import { Navbar, NavbarBrand, Nav, NavItem } from "react-bootstrap";
import { doLogout, getUser, isLoggedIn } from "../../services/user-service";
import "./TrusteeNavbar.css";
import { animateScroll as scroll } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

const TrusteeNavbar = (args) => {
  let navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);


  const user = getUser();

  const logout = () => {
    doLogout();
    navigate("/");
  };
  const [isPopupOpen, setPopupOpen] = useState(false);
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };
  const [imageSrc, setImageSrc] = useState("");
  const base64ToImage = () => {
    const base64String = user.image;
    const trimmedBase64 = base64String ? base64String.trim() : "";
    if (trimmedBase64) {
      setImageSrc(`data:image/jpeg;base64,${trimmedBase64}`);
    }
  };
  useEffect(() => {
    base64ToImage();
  }, []);
  return (
    <div>
      <Navbar className="navbar" expand="lg">
        <NavbarBrand style={{ paddingLeft: "20px" }}>
          <NavLink tag={ReactLink} to="/attorney/dashboard">
            <img
              className="navbar_logo_image"
              src="/logo192.png"
              alt="logoPng"
            />
          </NavLink>
        </NavbarBrand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          style={{ marginRight: "20px" }}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Link className="navbar_link pravas">
              <Nav.Link >
                <NavLink
                  className="navname"
                  tag={ReactLink}
                  to="/attorney/dashboard"
                >
                  Dashboard
                </NavLink>
              </Nav.Link>
            </Link>

            <Link className="navbar_link">
              <Nav.Link>
                <NavLink
                  className="navname"
                  tag={ReactLink}
                  to="/attorney/why-I-Chest"
                >
                  Why I-Chest
                </NavLink>
              </Nav.Link>
            </Link>
            <Link to="About" smooth={true} duration={50} className="navbar_link">
              <Nav.Link>
                <NavLink
                  className="navname"
                  onClick={() => alert("comming soon")}
                  tag={ReactLink}
                  to="#"
                >
                  Explore
                </NavLink>
              </Nav.Link>
            </Link>
            <Link to="projects" smooth={true} duration={50} className="navbar_link">
              <Nav.Link>
                <NavLink
                  className="navname"
                  onClick={() => alert("comming soon")}
                  tag={ReactLink}
                  to="#"
                >
                  User
                </NavLink>
              </Nav.Link>
            </Link>
            <Link to="Contact Us" smooth={true} duration={50} className="navbar_link">
              <Nav.Link>
                <NavLink
                  className="navname"
                  onClick={() => alert("comming soon")}
                  tag={ReactLink}
                  to="#"
                >
                  Beneficiary
                </NavLink>
              </Nav.Link>
            </Link>
          </Nav>
          <Nav navbar>
            <NavItem>
              <NavLink onClick={togglePopup} className="nav-user-name navbar_link">
                <img
                  src={imageSrc || "./../../.././img/avtar.jpg"}
                  alt="avtar_image"
                />
                {user.firstName + " "}
                {user.lastName}
                <FontAwesomeIcon
                  style={{ marginLeft: "10px" }}
                  icon={faCaretDown}
                />
              </NavLink>
            </NavItem>
            {isPopupOpen && (
              <div className="popup1">
                <ul>
                  <Link to="/attorney/profile" className="navbar_link">Profile</Link>
                  <Link to="/attorney/dashboard" className="navbar_link">Dashboard</Link>
                  <a className="navbar_link" onClick={logout}>Logout</a>
                </ul>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};
export default TrusteeNavbar;
